import { useEffect, useState } from 'react';
import { DataTable, Column } from '../../../shared/components';
import { getReportsRepository } from '../../../shared/services/reports/repositoryFactory';
import { ActivityKpiRow, ReportFilters } from '../../../shared/services/reports/types';
import { formatDuration } from '../../../shared/utils/datetime';
import { KpiPanelShell } from './KpiPanelShell';
import { KpiBarList } from './KpiBarList';

const repo = getReportsRepository();

export function ActivityKpiPanel({ filters }: { filters: ReportFilters }) {
  const [rows, setRows] = useState<ActivityKpiRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    repo.byActivity(filters, 1, 200).then((res) => {
      setRows(res.items);
      setIsLoading(false);
    });
  }, [filters]);

  const columns: Column<ActivityKpiRow>[] = [
    { key: 'activityName', header: 'Actividad', render: (r) => r.activityName, sortable: true, sortValue: (r) => r.activityName },
    { key: 'totalSeconds', header: 'Tiempo total', render: (r) => formatDuration(r.totalSeconds), sortable: true, sortValue: (r) => r.totalSeconds },
    { key: 'avgSeconds', header: 'Promedio por registro', render: (r) => formatDuration(r.avgSeconds) },
    { key: 'recordsCount', header: 'Registros', render: (r) => r.recordsCount },
  ];

  return (
    <KpiPanelShell title="Tiempo por actividad" subtitle="Tiempo total y promedio dedicado a cada actividad operativa">
      {!isLoading && (
        <div className="mb-4">
          <KpiBarList rows={rows.slice(0, 6).map((r) => ({ label: r.activityName, value: r.totalSeconds, displayValue: formatDuration(r.totalSeconds) }))} />
        </div>
      )}
      <DataTable columns={columns} rows={rows} rowKey={(r) => r.activityId} isLoading={isLoading} emptyTitle="Sin datos" pageSize={5} />
    </KpiPanelShell>
  );
}
